/* Bankari attribution contract v1. Canonical source: bankari.sk/js/marketing-attribution.js.
 * Copies in applications are checked byte-for-byte by tests. No external transmission here.
 */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else { root.BankariAttribution = factory(); root.BankariAttribution.install(root); }
}(typeof window !== 'undefined' ? window : this, function () {
  'use strict';
  var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_id', 'gad_campaignid', 'gclid', 'gbraid', 'wbraid', 'bk_campaign'];
  var HOSTS = ['bankari.sk', 'www.bankari.sk', 'analyza.bankari.sk', 'app.bankari.sk'];
  var STORAGE = 'bankari-attribution-v1';
  function parse(raw) {
    try {
      var u = new URL(raw);
      if (!/^https?:$/.test(u.protocol)) return null;
      var clean = new URL(u.origin + u.pathname);
      KEYS.forEach(function (k) { var v = u.searchParams.get(k); if (v) clean.searchParams.set(k, v.slice(0, 256)); });
      return clean;
    } catch (e) { return null; }
  }
  function tagged(url) { return url && KEYS.some(function (k) { return url.searchParams.has(k); }); }
  function read(win) {
    var current = parse(win.location.href), stored = null;
    try { stored = JSON.parse(win.sessionStorage.getItem(STORAGE)); } catch (e) { /* storage may be unavailable */ }
    var first = stored && parse(stored.first), last = stored && parse(stored.last);
    if (!first) first = current;
    if (!last || tagged(current)) last = current;
    var value = {version: 1, first: first ? first.href : '', last: last ? last.href : ''};
    try { win.sessionStorage.setItem(STORAGE, JSON.stringify(value)); } catch (e) { /* continue without persistence */ }
    return value;
  }
  function decorate(href, context, base) {
    try {
      var target = new URL(href, base), source = parse(context.last);
      if (!/^https?:$/.test(target.protocol) || HOSTS.indexOf(target.hostname) < 0 || !source || tagged(target)) return href;
      KEYS.forEach(function (k) { var v = source.searchParams.get(k); if (v) target.searchParams.set(k, v); });
      return target.href;
    } catch (e) { return href; }
  }
  function classify(raw) {
    var u = parse(raw);
    if (!u) return {label: 'Neznámy pôvod', className: 'source-default'};
    var p = u.searchParams, medium = (p.get('utm_medium') || '').toLowerCase(), source = (p.get('utm_source') || '').toLowerCase();
    var google = ['gclid', 'gbraid', 'wbraid', 'gad_campaignid'].some(function(k) { return p.has(k); }) || (source === 'google' && ['cpc','ppc','paid','paidsearch'].indexOf(medium) >= 0);
    if (google) return {label: 'Ads' + ((p.get('gad_campaignid') || p.get('utm_id') || p.get('utm_campaign')) ? ' • ' + (p.get('gad_campaignid') || p.get('utm_id') || p.get('utm_campaign')) : ''), className: 'source-ads'};
    if (medium === 'organic') return {label: 'Organika', className: 'source-organika'};
    if (['cpc','ppc','paid','paid_social','paidsearch'].indexOf(medium) >= 0) return {label: 'Platená návštevnosť', className: 'source-ads'};
    if (medium === 'referral') return {label: 'Odporúčanie', className: 'source-dev'};
    return {label: 'Neurčený kanál', className: 'source-default'};
  }
  function install(win) {
    if (!win || win.__bankariAttributionInstalled) return;
    win.__bankariAttributionInstalled = true;
    read(win);
    win.document.addEventListener('click', function (event) {
      var a = event.target && event.target.closest && event.target.closest('a[href]');
      if (a && !a.hasAttribute('download')) a.href = decorate(a.href, read(win), win.location.href);
    }, true);
    function frames() {
      win.document.querySelectorAll('iframe[src]').forEach(function(frame) {
        var old = frame.getAttribute('src'), next = decorate(old, read(win), win.location.href);
        if (old !== next) frame.setAttribute('src', next);
      });
    }
    if (win.document.readyState === 'loading') win.document.addEventListener('DOMContentLoaded', frames);
    else frames();
    if (win.MutationObserver) new win.MutationObserver(frames).observe(win.document.documentElement, {childList: true, subtree: true});
  }
  return {version: 1, parse: parse, read: read, decorate: decorate, classify: classify, install: install};
}));
